import React, { useState, useEffect } from 'react';

const PerfilPage = ({ onNavigate, nomeUsuario, abaMostrar = 'estoque' }) => {
  const [insumos, setInsumos] = useState([]);
  const [perfil, setPerfil] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [mostrarPerfil, setMostrarPerfil] = useState(abaMostrar === 'perfil');
  
  const [novoInsumo, setNovoInsumo] = useState({ 
    nome: '', 
    quantidade: '', 
    unidade: 'kg' 
  });

  const restauranteId = localStorage.getItem('restauranteId');

  // Sincronizar estado com a prop abaMostrar
  useEffect(() => {
    setMostrarPerfil(abaMostrar === 'perfil');
  }, [abaMostrar]);

  // Carregar dados ao montar o componente
  useEffect(() => {
    carregarDados();
  }, []);

  const carregarDados = async () => {
    await Promise.all([carregarInsumos(), carregarPerfil()]);
  };

  const carregarPerfil = async () => {
    if (!restauranteId) return;

    try {
      const response = await fetch(`http://localhost:3000/restaurantes/${restauranteId}`);
      
      if (response.ok) {
        const data = await response.json();
        setPerfil(data);
      } else {
        console.error('Erro ao carregar perfil');
      }
    } catch (error) {
      console.error('Erro ao carregar perfil:', error);
    }
  };

  const carregarInsumos = async () => {
    if (!restauranteId) {
      setError('ID do restaurante não encontrado');
      setLoading(false);
      return;
    }

    try {
      const response = await fetch(`http://localhost:3000/insumos?restauranteId=${restauranteId}`);
      
      if (response.ok) {
        const data = await response.json();
        setInsumos(data);
        setError('');
      } else {
        const errorText = await response.text();
        console.error('Erro ao carregar insumos:', errorText);
        setError('Erro ao carregar insumos');
      }
    } catch (error) {
      console.error('Erro de conexão:', error);
      setError('Erro de conexão com o servidor');
    } finally {
      setLoading(false);
    }
  };

  const handleAddInsumo = async (event) => {
    event.preventDefault();
    setError('');
    setSuccess('');

    const quantidade = parseFloat(novoInsumo.quantidade);
    if (isNaN(quantidade) || quantidade <= 0) {
      setError('Quantidade deve ser um número positivo');
      return;
    }

    const dadosParaEnviar = {
      consumidorId: restauranteId,
      nome: novoInsumo.nome.trim(),
      quantidade: quantidade,
      unidade: novoInsumo.unidade
    };

    try {
      const response = await fetch('http://localhost:3000/insumos', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(dadosParaEnviar),
      });

      if (response.ok) {
        const data = await response.json();
        setSuccess('Insumo adicionado com sucesso!');
        setNovoInsumo({ nome: '', quantidade: '', unidade: 'kg' });
        
        // Recarregar lista de insumos
        await carregarInsumos();
      } else {
        const errorData = await response.json();
        setError(errorData.error || 'Erro ao adicionar insumo');
      }
    } catch (error) {
      console.error('Erro de rede:', error);
      setError('Erro de conexão com o servidor');
    }
  };

  const handleRemoveInsumo = async (id) => {
    if (!window.confirm('Deseja realmente excluir este insumo?')) {
      return;
    }

    try {
      const response = await fetch(`http://localhost:3000/insumos/${id}`, {
        method: 'DELETE'
      });

      if (response.ok) {
        setSuccess('Insumo removido com sucesso!');
        await carregarInsumos();
      } else {
        const errorData = await response.json();
        setError(errorData.error || 'Erro ao remover insumo');
      }
    } catch (error) {
      console.error('Erro de rede:', error);
      setError('Erro de conexão com o servidor');
    }
  };
  
  const handleEditProfile = () => {
    onNavigate('EditarCadastro'); 
  };
  
  const handleLogout = () => {
    localStorage.clear();
    onNavigate('Home', ''); 
  };


  return (
    <div className="profile-container">
      {/* Mensagens de erro e sucesso */}
      <div className="profile-content">
        {error && (
          <div className="alert alert-error">
            <span className="alert-icon">⚠️</span>
            <span className="alert-text">{error}</span>
          </div>
        )}
        {success && (
          <div className="alert alert-success">
            <span className="alert-icon">✓</span>
            <span className="alert-text">{success}</span>
          </div>
        )}

        {/* Seção de Visualização de Perfil */}
        {mostrarPerfil && perfil && (
          <div className="profile-data-section">
            {/* Card de Informações do Negócio */}
            <div className="data-card">
              <div className="data-card-header">
                <h3 className="data-card-title">
                  <span className="data-icon">🏢</span>
                  Informações do Negócio
                </h3>
                <button 
                  className="btn-edit-small"
                  onClick={handleEditProfile}
                  title="Editar informações"
                >
                  <span>✏️</span> Editar
                </button>
              </div>

              <div className="data-grid">
                <div className="data-item">
                  <label className="data-label">Nome do Estabelecimento</label>
                  <p className="data-value">{perfil.nome || '-'}</p>
                </div>
                
                <div className="data-item">
                  <label className="data-label">CNPJ</label>
                  <p className="data-value">{perfil.cnpj || '-'}</p>
                </div>
                
                <div className="data-item">
                  <label className="data-label">E-mail</label>
                  <p className="data-value">{perfil.email || '-'}</p>
                </div>
                
                <div className="data-item">
                  <label className="data-label">Telefone</label>
                  <p className="data-value">{perfil.telefone || '-'}</p>
                </div>
              </div>
            </div>

            {/* Card de Endereço */}
            <div className="data-card">
              <div className="data-card-header">
                <h3 className="data-card-title">
                  <span className="data-icon">📍</span>
                  Endereço
                </h3>
              </div>

              <div className="data-grid">
                <div className="data-item">
                  <label className="data-label">CEP</label>
                  <p className="data-value">{perfil.cep || '-'}</p>
                </div>
                
                <div className="data-item full-width">
                  <label className="data-label">Logradouro</label>
                  <p className="data-value">{perfil.rua || perfil.logradouro || '-'}</p>
                </div>
                
                <div className="data-item">
                  <label className="data-label">Número</label>
                  <p className="data-value">{perfil.numero || '-'}</p>
                </div>
                
                <div className="data-item">
                  <label className="data-label">Complemento</label>
                  <p className="data-value">{perfil.complemento || '-'}</p>
                </div>
                
                <div className="data-item">
                  <label className="data-label">Bairro</label>
                  <p className="data-value">{perfil.bairro || '-'}</p>
                </div>
                
                <div className="data-item">
                  <label className="data-label">Cidade</label>
                  <p className="data-value">{perfil.cidade || '-'}</p>
                </div>
                
                <div className="data-item">
                  <label className="data-label">Estado</label>
                  <p className="data-value">{perfil.estado || '-'}</p>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Seção de Controle de Estoque */}
        {!mostrarPerfil && (
          <div className="inventory-section">
            {/* Card de Adicionar Insumo */}
            <div className="inventory-add-card">
              <div className="card-header-modern">
                <h3 className="card-title-modern">
                  <span className="card-icon">➕</span>
                  Adicionar Novo Insumo
                </h3>
                <p className="card-subtitle">Cadastre os ingredientes que você precisa</p>
              </div>
              
              <form onSubmit={handleAddInsumo} className="inventory-form-modern">
                <div className="form-row">
                  <div className="form-group-modern">
                    <label className="form-label-modern">Nome do Insumo</label>
                    <input
                      type="text"
                      className="form-input-modern"
                      placeholder="Ex: Tomate, Alface, Feijão..."
                      value={novoInsumo.nome}
                      onChange={(e) => setNovoInsumo({...novoInsumo, nome: e.target.value})}
                      required
                    />
                  </div>
                  
                  <div className="form-group-modern">
                    <label className="form-label-modern">Quantidade</label>
                    <input
                      type="number"
                      className="form-input-modern"
                      step="0.01"
                      min="0.01"
                      placeholder="0.00"
                      value={novoInsumo.quantidade}
                      onChange={(e) => setNovoInsumo({...novoInsumo, quantidade: e.target.value})}
                      required
                    />
                  </div>
                  
                  <div className="form-group-modern">
                    <label className="form-label-modern">Unidade</label>
                    <select
                      className="form-select-modern"
                      value={novoInsumo.unidade}
                      onChange={(e) => setNovoInsumo({...novoInsumo, unidade: e.target.value})}
                      required
                    >
                      <option value="kg">kg (Quilograma)</option>
                      <option value="g">g (Grama)</option>
                      <option value="l">l (Litro)</option>
                      <option value="ml">ml (Mililitro)</option>
                      <option value="un">un (Unidade)</option>
                      <option value="cx">cx (Caixa)</option>
                      <option value="pc">pc (Pacote)</option>
                      <option value="dz">dz (Dúzia)</option>
                    </select>
                  </div>
                </div>
                
                <button type="submit" className="btn-add-modern">
                  <span className="btn-icon">➕</span>
                  Adicionar ao Estoque
                </button>
              </form>
            </div>

            {/* Card de Lista de Insumos */}
            <div className="inventory-list-card">
              <div className="card-header-modern">
                <h3 className="card-title-modern">
                  <span className="card-icon">📦</span>
                  Meu Estoque de Insumos
                </h3>
                <p className="card-subtitle">
                  {insumos.length > 0 ? `${insumos.length} ${insumos.length === 1 ? 'item cadastrado' : 'itens cadastrados'}` : 'Nenhum item ainda'}
                </p>
              </div>
              
              {loading ? (
                <div className="empty-state-modern">
                  <div className="loading-spinner-modern"></div>
                  <p className="loading-text">Carregando insumos...</p>
                </div>
              ) : insumos.length === 0 ? (
                <div className="empty-state-modern">
                  <span className="empty-icon-large">📭</span>
                  <h4 className="empty-title">Nenhum insumo cadastrado</h4>
                  <p className="empty-description">Comece adicionando os ingredientes que você precisa no formulário acima.</p>
                </div>
              ) : (
                <div className="inventory-grid">
                  {insumos.map((insumo) => (
                    <div key={insumo.id} className="insumo-card">
                      <div className="insumo-card-header">
                        <h4 className="insumo-name">{insumo.nome}</h4>
                        <button 
                          onClick={() => handleRemoveInsumo(insumo.id)}
                          className="btn-delete-modern"
                          title="Excluir insumo"
                        >
                          🗑️
                        </button>
                      </div>
                      <div className="insumo-card-body">
                        <div className="insumo-quantity">
                          <span className="quantity-value">{insumo.quantidade}</span>
                          <span className="quantity-unit">{insumo.unidade}</span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PerfilPage;